import React from 'react'
import { Text, View } from 'styles/reactnative'
import { COLORS } from 'app/constants'

const AdminSubTitle = ({ title = '', buttons = [], CustomComp }: any) => {
	return (
		<View
			style={{
				width: '100%',
				flexDirection: 'row',
				justifyContent: 'space-between',
				minHeight: 40,
				background: COLORS.gray2,
				padding: 10,
				marginTop: 10,
				borderTopLeftRadius: 10,
				borderTopRightRadius: 10,
			}}>
			<View>
				<Text
					size={20}
					style={{
						color: COLORS.white,
						fontSize: 17,
						fontWeight: '600',
					}}>
					{title}
				</Text>
			</View>
			{CustomComp
				? CustomComp
				: buttons?.map((button, index) => {
						return <View key={index}>{button}</View>
				  })}
		</View>
	)
}

export default React.memo(AdminSubTitle)
